import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectHeatIndex } from '../../../selectors/heatIndex/selectHeatIndex';
import { IHeatIndexScale, IHeatIndex } from '../../../types/heatIndex';
import { useApplicationContext } from '../../ApplicationContext';

export function useHeatIndex(): IHeatIndex | null {
  const { config } = useApplicationContext();
  const heatIndex = useSelector(selectHeatIndex);

  return useMemo(() => {
    const intervals = config.get<IHeatIndexScale[]>('heatIndexScaleV2') || [];
    if (typeof heatIndex === 'number' && intervals.length > 0) {
      // дробный индекс может быть 0 < x <= 1, в интерфейсе отображаем минимум 1
      const roundedIndex = Math.max(1, Math.round(heatIndex));
      intervals.sort((intervalA, intervalB) => Math.max(...intervalA.range) - Math.max(...intervalB.range));

      const interval = intervals.find((interval, intervalIndex) =>
        intervalIndex !== intervals.length - 1
          ? interval.range[0] <= roundedIndex && roundedIndex < interval.range[1]
          : interval.range[0] <= roundedIndex && roundedIndex <= interval.range[1],
      );

      if (interval) {
        return {
          title: interval.title,
          description: interval.description,
          value: roundedIndex,
        };
      }
    }

    return null;
  }, [heatIndex, config]);
}
